import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PageTitle from "../../../components/partials/PageTitle";
import Select from "../../../components/form/select/Select";
import { fetchAllOffices } from "../../../redux/slice/office/officeSlice";
import { getAllRoles } from "../../../redux/slice/staff/staffSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSingleUser,
  resetUsers,
  updateUser,
} from "../../../redux/slice/user/userSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { BounceLoader } from "react-spinners";
import { flashMessage as flash } from "../../../utils/flash";

const EditUser = () => {
  const location = useLocation();

  const [userValue, setUserValue] = useState({
    first_name: "",
    last_name: "",
    email: "",
    staff_id: "",
    office_id: "",
    roles: "",
    status: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [firstLogin, setFirstLogin] = useState(false);
  const [rolesSelect, setRolesSelect] = useState(
    location?.state?.[0].roles?.map((item) => {
      return { role_name: item.name };
    }) || null
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { offices } = useSelector((state) => state.office);
  const { roles } = useSelector((state) => state.staff);
  const { user } = useSelector((state) => state.auth?.user);
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const { id } = useParams();

  const { staff_information } = useSelector((state) => state?.staff);
  const { isSuccess, isLoading } = useSelector((state) => state?.user);

  const breadcrumb = {
    from: {
      title: "User",
      link: "/admin/all-users",
    },
    current: {
      title: "edit",
      link: null,
    },
  };

  const onSubmit = (values) => {
    if (!rolesSelect.length) {
      return flash("error", "Atleast one role is required");
    }

    let payload = { ...values, roles_arrays: rolesSelect, id: id, first_login: firstLogin,  };
    dispatch(updateUser(payload));
    setSubmitted(true);
    // setUserValue({ firstname: '', lastname: '', email:'', staffId: '' })
    // resetForm();
  };

  const handleRoleSelect = (e) => {
    let object = { role: e.target.value, checked: e.target.checked };
    if (!object.checked) {
      let sorted = rolesSelect.filter((item) => item.role_name !== object.role);
      setRolesSelect(sorted);
    } else setRolesSelect([...rolesSelect, { role_name: object.role }]);
  };

  const validationScehma = Yup.object().shape({
    staff_id: Yup.string("Staff Id must be a string").required(
      "Staff Id cannot be blank"
    ),
    first_name: Yup.string("First Name must be a string").required(
      "First Name cannot be blank"
    ),
    last_name: Yup.string("Last Name must be a string").required(
      "Last Name cannot be blank"
    ),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    // password: Yup.string().required("Password cannot be blank"),
    office_id: Yup.string().required("Office is required"),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      staff_id: userValue?.staff_id || "",
      first_name: userValue?.first_name || "",
      last_name: userValue?.last_name || "",
      email: userValue?.email || "",
      password: "",
      office_id: userValue?.office_id || "",
    },
    validationSchema: validationScehma,
    onSubmit,
  });

  const officeData = offices?.offices?.map((office) => {
    return {
      label: office.office_name,
      value: office.id,
    };
  });

  useEffect(() => {
    dispatch(fetchSingleUser(id));

    dispatch(fetchAllOffices({ office_id: user?.office_id, pageNumber: 1 }));

    dispatch(getAllRoles());
  }, [dispatch, id, staff_information, user?.office_id]);

  useEffect(() => {
    if (isSuccess && submitted) {
      navigate("/admin/all-users");
      dispatch(resetUsers());
      setSubmitted(false);
    }
  }, [dispatch, isSuccess, navigate, submitted]);

  useEffect(() => {
    if (isSuccess) {
      setUserValue({
        first_name: location.state[0].first_name,
        last_name: location.state[0].last_name,
        staff_id: location.state[0].staff_id,
        email: location.state[0].email,
        office_id: location.state[0].office_id,
        status: location.state[0].status,
      });
      setRolesSelect(
        location.state[0].roles?.map((item) => {
          return { role_name: item.name };
        })
      );
      return;
    }
  }, [dispatch, isSuccess, location.state]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(resetUsers());
      return;
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "user module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "view user details"
      ) ||
      !user_permissions?.some((permission) => permission.name === "edit user")
    ) {
      navigate("/admin/dashboard");
    }
  }, [location, navigate, user_permissions]);

  if (isLoading) {
    return (
      <div className='d-flex mt-lg-5 justify-content-center align-content-center'>
        <BounceLoader color='#2E3192' size={"70px"} />
      </div>
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title='Edit User' breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <form onSubmit={handleSubmit}>
              <div className='card-body'>
                <div className='row mb-3'>
                  <div className='col-sm-2 text-right sm-text-end'>
                    <label for='staff_id' className='col-form-label'>
                      Staff Id
                      <span className='text-danger'> *</span>
                    </label>
                  </div>
                  <div class='col-sm-6'>
                    <input
                      disabled
                      type='text'
                      name='staff_id'
                      className='form-control form-control-sm'
                      id='staff_id'
                      value={values?.staff_id}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors?.staff_id && touched?.staff_id && (
                      <p className='mb-0 text-danger'>
                        {errors?.staff_id + "*"}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-sm-2 text-right sm-text-end'>
                    <label htmlFor='first_name' className='col-form-label'>
                      Firstname
                      <span className='text-danger'> *</span>
                    </label>
                  </div>
                  <div class='col-sm-6'>
                    <input
                      type='text'
                      className='form-control form-control-sm'
                      id='first_name'
                      value={values?.first_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors?.first_name && touched?.first_name && (
                      <p className='mb-0 text-danger'>
                        {errors?.first_name + "*"}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-sm-2 text-right sm-text-end'>
                    <label htmlFor='last_name' className='col-form-label'>
                      Lastname
                      <span className='text-danger'> *</span>
                    </label>
                  </div>
                  <div class='col-sm-6'>
                    <input
                      type='text'
                      className='form-control form-control-sm'
                      id='last_name'
                      value={values?.last_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors?.last_name && touched?.last_name && (
                      <p className='mb-0 text-danger'>
                        {errors?.last_name + "*"}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-sm-2 text-right sm-text-end'>
                    <label htmlFor='Email' className='col-form-label'>
                      Email<span className='text-danger'> *</span>
                    </label>
                  </div>
                  <div class='col-sm-6'>
                    <input
                      type='email'
                      className='form-control form-control-sm'
                      id='email'
                      value={values?.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors?.email && touched?.email && (
                      <p className='mb-0 text-danger'>{errors?.email + "*"}</p>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-sm-2 text-right sm-text-end'>
                    <label htmlFor='password' className='col-form-label'>
                      Password
                    </label>
                  </div>
                  <div class='col-sm-6'>
                    <input
                      type='password'
                      className='form-control form-control-sm'
                      id='password'
                      value={values?.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors?.password && touched?.password && (
                      <p className='mb-0 text-danger'>
                        {errors?.password + "*"}
                      </p>
                    )}
                    <div className='flex align-items-center mt-2'>
                      <input
                        className={`form-check-input`}
                        type='checkbox'
                        id='firstLogin'
                        name='firstLogin'
                        onChange={() => setFirstLogin(!firstLogin)}
                        style={{ height: "20px", width: "20px" }}
                      />
                      <label
                        className='form-label'
                        htmlFor='firstLogin'
                        style={{
                          textAlign: "left",
                          paddingLeft: "15px",
                          width: "65%",
                        }}
                      >
                        <p className=''>
                          Require User to change password on login
                        </p>
                      </label>
                    </div>
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-sm-2 text-end sm-text-end'>
                    <label htmlFor='account_type' className={`form-label mt-1`}>
                      Office <span className='text-danger'>*</span>
                    </label>
                  </div>

                  <div className='col-sm-6'>
                    <Select
                      onBlur={() => {
                        handleBlur({ target: { name: "office" } });
                      }}
                      name='office'
                      data={officeData}
                      value={parseInt(values?.office_id)}
                      onChange={(selectedOption) =>
                        setFieldValue("office_id", selectedOption?.value)
                      }
                    />
                    {errors?.office && touched?.office && (
                      <p className='mb-0 text-danger'>{errors?.office + "*"}</p>
                    )}
                  </div>
                </div>
                <div className='flex align-items-center'>
                  {roles?.roles?.map((role, index) => (
                    <div key={index}>
                      <label
                        className='form-label'
                        htmlFor='superUser'
                        style={{
                          textAlign: "right",
                          paddingRight: "25px",
                          width: "17%",
                        }}
                      >
                        <p>{role}</p>
                      </label>
                      <input
                        className={`form-check-input`}
                        type='checkbox'
                        id={role}
                        value={role}
                        name={role}
                        onChange={(e) => handleRoleSelect(e)}
                        style={{ height: "20px", width: "20px" }}
                        defaultChecked={rolesSelect?.some(
                          (item) => item.role_name === role
                        )}
                        // defaultChecked={rolesSelect.some((item) => item === role)}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className='row mb-3'>
                <div className='col-sm-2'></div>
                <div className='col-sm-6 d-flex gap-3'>
                  <button
                    type='submit'
                    className='btn btn-primary btn-md px-4 rounded'
                  >
                    Update
                  </button>
                  <button
                    type='button'
                    className='btn btn-info btn-md px-4 rounded'
                    onClick={() => navigate(-1)}
                  >
                    Go Back
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditUser;
